(function () {
  var SCRIPT_SELECTOR = 'script[data-trustpilot-footer-script]';
  var WIDGET_SELECTOR = '[data-trustpilot-lazy]';
  var hasLoaded = false;

  function hydrateWidgets() {
    if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== 'function') return;

    document.querySelectorAll(WIDGET_SELECTOR).forEach(function (widget) {
      if (widget.dataset.trustpilotHydrated === 'true') return;
      widget.dataset.trustpilotHydrated = 'true';
      window.Trustpilot.loadFromElement(widget, true);
    });
  }

  function loadScript() {
    if (hasLoaded) {
      hydrateWidgets();
      return;
    }

    hasLoaded = true;

    if (window.Trustpilot && typeof window.Trustpilot.loadFromElement === 'function') {
      hydrateWidgets();
      return;
    }

    if (document.querySelector(SCRIPT_SELECTOR)) return;

    var script = document.createElement('script');
    script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    script.async = true;
    script.dataset.trustpilotFooterScript = 'true';
    script.onload = hydrateWidgets;
    document.head.appendChild(script);
  }

  function init() {
    var widgets = document.querySelectorAll(WIDGET_SELECTOR);
    if (!widgets.length) return;

    if (!('IntersectionObserver' in window)) {
      window.addEventListener('load', loadScript, { once: true });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;

        observer.disconnect();
        loadScript();
      },
      {
        rootMargin: '240px 0px'
      }
    );

    widgets.forEach(function (widget) {
      observer.observe(widget);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
    return;
  }

  init();
})();
